import { BaseTableManagement } from 'app/components/tables/BaseTableManagement'
import styled from 'styled-components'

export const TableWrapper = styled(BaseTableManagement)``
